import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { splitTime } from "../../../_helper";
import { useDispatch, useSelector } from "react-redux";
import RatingReview from "../../../Components/RatingReview";
import PageTitle from "../../../Components/UI/PageTitle";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { getCourseDetailsBeforePurchase } from "../../../apis";

const ViewCourse = () => {
  const [courseDetails, setCourseDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [courseInstructorDetails, setCourseInstructorDetails] = useState([]);
  const { lang } = useSelector((state) => state?.UI);

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    getCourseDetailsBeforePurchase(id)
      .then((response) => {
        setCourseDetails(response.data.data?.[0]);
        setCourseInstructorDetails(response.data.data?.[0]?.instructor);
      })
      .catch((error) => {
        console.log(error);
        setError(error.response.data.message ?? error?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, dispatch]);

  if (error) return <ErrorAnimationComponent message={error} />;
  if (isLoading) return <Loader />;

  return (
    <>
      <PageTitle
        title={courseDetails?.[`course_name_${lang}`]}
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Add New Course",
            link: `/partners/add-new-course`,
          },
          { title: courseDetails?.[`course_name_${lang}`] },
        ]}
      />
      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            {courseDetails?.course_promo_video && (
              <iframe
                title={courseDetails?.course_name_en}
                src={`${courseDetails?.course_promo_video}`}
                width="100%"
                height="480"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
            <div className="card-body">
              {courseDetails[`course_description_${lang}`]}
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          {courseInstructorDetails?.length > 0 &&
            courseInstructorDetails?.map((instructor) => (
              <div className="card" key={instructor?.instructor_id}>
                <div className="card-header">
                  <div className="media align-items-center">
                    <div className="media-left">
                      <div
                        className=" rounded-circle tw-overflow-hidden"
                        style={{ width: 75, height: 75 }}
                      >
                        <img
                          src={
                            instructor[`instructor_image`] ||
                            "/imgs/partner.png"
                          }
                          alt={instructor[`instructor_name_${lang}`]}
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                    </div>

                    <div className="media-body d-flex flex-column">
                      <h4 className="card-title">
                        <span href="fixed-instructor-profile.html">
                          {instructor[`instructor_name_${lang}`]}
                        </span>
                      </h4>
                      <p className="card-subtitle">
                        {instructor[`instructor_title_${lang}`]}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <p>{instructor[`instructor_bio_${lang}`]}</p>
                </div>
              </div>
            ))}

          <div className="card">
            <ul className="list-group list-group-fit">
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">schedule</i>
                  </div>
                  <div className="media-body">
                    {splitTime(courseDetails?.course_duration)?.hours}{" "}
                    <small className="text-muted">hrs</small> &nbsp;{" "}
                    {splitTime(courseDetails?.course_duration)?.mins}{" "}
                    <small className="text-muted">min</small>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">
                      assessment
                    </i>
                  </div>
                  <div className="media-body flex flex-column">
                    {courseDetails?.course_level}
                    <div className=""></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Course Rating */}
          <div className="card">
            <div className="card-header tw-flex tw-justify-between tw-items-center">
              <h4 className="card-title !tw-m-0">Course Rate</h4>
              <RatingReview
                totalStars={5}
                currentRating={courseDetails?.course_rating || 0}
                editable={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCourse;
